import { number, object, ObjectSchema, string, mixed, boolean } from "yup";
import { MapProvider } from "./types";
import type { Options } from "./types";

type MarkerIcon = "house" | "pin";
type DistanceUnit = "metric" | "imperial";

const scoreObject = object({
  hide: boolean().optional(),
  hideScore: boolean().optional(),
  order: number().optional(),
}).optional();

const colorsObject = object({
  background: string().required(),
  fill: string().required(),
}).optional();

const scoresMenu = object({
  defaultOpen: boolean().optional(),
  title: mixed<string | boolean>().optional(),
  categories: object({
    transport: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        pedestrian_friendly: scoreObject,
        transit_friendly: scoreObject,
        cycling_friendly: scoreObject,
        car_friendly: scoreObject,
      }).optional(),
    }).optional(),
    education: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        daycares: scoreObject,
        primary_schools: scoreObject,
        high_schools: scoreObject,
      }).optional(),
    }).optional(),
    amenities: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        shopping: scoreObject,
        groceries: scoreObject,
        restaurants: scoreObject,
        cafes: scoreObject,
      }).optional(),
    }).optional(),
    character: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        nightlife: scoreObject,
        vibrant: scoreObject,
        historic: scoreObject,
        quiet: scoreObject,
      }).optional(),
    }).optional(),
    nature: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        parks: scoreObject,
        greenery: scoreObject,
      }).optional(),
    }).optional(),
    wellness: object({
      hide: boolean().optional(),
      order: number().optional(),
      colors: colorsObject,
      scores: object({
        wellness: scoreObject,
      }).optional(),
    }).optional(),
  }).optional(),
})
  .optional()
  .default({
    defaultOpen: true,
  });

export const schema: ObjectSchema<Options> = object({
  lat: number()
    .min(-90, "Must be a valid latitude.")
    .max(90, "Must be a valid latitude.")
    .required(),
  lng: number()
    .min(-180, "Must be a valid longitude.")
    .max(180, "Must be a valid longitude.")
    .required(),
  zoom: number().optional(),
  pitch: number().optional(),
  bearing: number().optional(),
  distanceUnit: mixed<DistanceUnit>().oneOf(["metric", "imperial"]).optional(),
  marker: object({
    lat: number()
      .min(-90, "Must be a valid latitude.")
      .max(90, "Must be a valid latitude.")
      .required(),
    lng: number()
      .min(-180, "Must be a valid longitude.")
      .max(180, "Must be a valid longitude.")
      .required(),
    icon: mixed<MarkerIcon>().oneOf(["house", "pin"]).optional(),
    addressLabel: string().optional(),
  }).default(undefined),
  cooperativeGestures: boolean().optional(),
  mapProvider: mixed<MapProvider>().optional(),
  hideScores: boolean().optional(),
  // TODO Might not need this
  collapseScores: boolean().optional(),
  scoresMenu,
}).noUnknown(true);

export const validateOptions = (options: Options) =>
  schema.validate(options, { abortEarly: false });
